import React from 'react'
import PropTypes from 'prop-types'

const CollapsableCard = ({ children }) => {
  return <div>{children}</div>
}

CollapsableCard.propTypes = {
  children: PropTypes.node.isRequired,
}

export default CollapsableCard
